const boardList = [
  {
    id: 2,
    name: "入驻流程",
    des: "入驻前先看，新手开店不用慌",
    img: require("@/assets/image/16.png")
  },
  {
    id: 3,
    name: "资质要求",
    des: "了解店铺类型/入驻资料/填写要求",
    img: require("@/assets/image/17.png")
  },
  // {
  //   id: 4,
  //   name: "常见问题",
  //   des: "帮你解决入驻过程中的各类问题",
  //   img: require("@/assets/image/18.png")
  // },
]
const reasonList = [
  {
    img: require("@/assets/image/19.png"),
    title: "海量活动用户",
    des: "成为用户群，销量轻松增长",
  },
  {
    img: require("@/assets/image/20.png"),
    title: "超高平台知名度",
    des: "信任是基石，成就加速度",
  },
  {
    img: require("@/assets/image/21.png"),
    title: "新电商升级创者",
    des: "拼单分享，卖货不停",
  },
  {
    img: require("@/assets/image/22.png"),
    title: "免费开店",
    des: "U开金 无扣点",
  },
  {
    img: require("@/assets/image/23.png"),
    title: "新商家扶持",
    des: "扶持力度大，流量强推升",
  },
  {
    img: require("@/assets/image/24.png"),
    title: "海量活动每天报名",
    des: "诚意活动多，用户忙到手",
  },
  {
    img: require("@/assets/image/25.png"),
    title: "拼多多课堂",
    des: "免费带你学电商，小白变商家",
  },
  {
    img: require("@/assets/image/26.png"),
    title: "官方培训基地",
    des: "系统培训课程，助力成长",
  },
]


export {
  boardList,
  reasonList
};